/* import __COLOCATED_TEMPLATE__ from './seller-postings-search-text.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

class SellerPostingsTabBarSearchComponent extends Component {
  @tracked input = '';
  @tracked isDirty = false;

  get value() {
    const value = this.isDirty ? this.input : this.args.value;
    return value ?? '';
  }

  @action
  onChange(e) {
    this.input = e.target.value;
    this.isDirty = true;
  }

  @action
  onBlur() {
    this.input = '';
    this.isDirty = false;
  }

  @action
  onSubmit(e) {
    e.preventDefault();

    const input = this.input;
    const value = this.args.value ?? '';

    this.input = '';
    this.isDirty = false;

    if (input !== value) {
      this.args.onChange(input);
    }
  }
}

export default SellerPostingsTabBarSearchComponent;
